import React from 'react';
import { Container, Button } from 'react-bootstrap';

function PhoneUnavailableMessage({ gameTitle = "Spiel", onBackToGames }) {
  return (
    <Container>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        minWidth: '50vw',
        textAlign: 'center',
        padding: '20px 20px'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '10px',
          borderRadius: '20px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
          maxWidth: '600px',
          border: '3px solid #FF6B6B'
        }}>
          <div style={{
            fontSize: '64px',
            marginBottom: '20px'
          }}>
            📱🚫
          </div>
          <h2 style={{
            color: '#FF6B6B',
            marginBottom: '20px',
            fontWeight: 'bold'
          }}>
            Nicht verfügbar auf dem Handy
          </h2>
          <p style={{
            fontSize: '18px',
            color: '#4A4A4A',
            lineHeight: '1.6',
            marginBottom: '30px'
          }}>
            Das {gameTitle} kann nicht auf dem Handy gespielt werden. 
            Bitte verwenden Sie einen <strong>Computer</strong> oder ein <strong>Tablet</strong> für die beste Spielerfahrung.
          </p>
          {onBackToGames && (
            <Button
              onClick={onBackToGames}
              variant="primary"
              size="lg"
              style={{
                backgroundColor: '#FF6B6B',
                borderColor: '#FF6B6B',
                padding: '12px 30px',
                fontSize: '16px',
                fontWeight: 'bold',
                borderRadius: '25px'
              }}
            >
              Zurück zu den Spielen
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
}

export default PhoneUnavailableMessage;